import { chosenModelsFitOneRun } from "@shared/types/transformations";

/**
 * What the Models view's "Run selected" opens (round 6 T-29, review r1).
 *
 * A run of the chosen models (`chosen`), even with every model chosen: it builds exactly those
 * models, whatever the enabled dbt jobs select, and keeps "Also build the models they depend on"
 * and "Run their tests". Only every model chosen in a project too big for one run (more than
 * `MAX_CHOSEN_MODELS` names or a selection past `MAX_DBT_SELECT_LENGTH`) becomes "Run all dbt
 * jobs now" (`all-jobs`), which sends no list, so choosing every model never ends at a refusal.
 * A part of the models past the limit stays `chosen`: the dialog says "Too many models chosen".
 */
export function runSelectedAs(models: readonly string[], every: boolean): "chosen" | "all-jobs" {
  return every && !chosenModelsFitOneRun(models, false) ? "all-jobs" : "chosen";
}
